var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "114.124mm",
    height: "65.9251mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 9920 5730",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 2973.24,
    y1: 1349.48,
    x2: 6946.54,
    y2: 1349.48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D948B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70BF53"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_724869152"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#006F87",
    d: "M8015 4347c190,0 244,111 244,274l-533 0c25,-51 10,-274 289,-274zm-381 320c0,448 347,460 686,396l0 -76c-110,2 -347,93 -502,-46 -75,-67 -67,-120 -92,-228l625 0c0,-263 -24,-442 -366,-442 -127,0 -192,41 -256,110 -56,61 -95,176 -95,286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006F87",
    d: "M9234 5093l91 0 0 -609c0,-108 503,-263 503,61l0 548 91 0 0 -518c0,-238 -131,-305 -335,-305 -143,0 -161,53 -259,76l0 -381 -91 0 0 1127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006F87",
    d: "M8457 4667c0,103 37,233 86,294 145,181 359,133 553,117l0 -76c-173,0 -533,124 -533,-350 0,-391 455,-311 533,-274l0 -91c-139,0 -640,-125 -640,381z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006F87",
    d: "M7239 4926c0,197 218,168 320,168l0 -76c-285,0 -229,48 -229,-670l229 0 0 -76 -228 0 1 -137 -92 0 0 792z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#005162",
    fillRule: "nonzero",
    d: "M80 5017l0 -364c187,78 402,116 647,116 182,0 274,-61 274,-182 0,-116 -62,-174 -184,-174l-304 0c-341,0 -512,-174 -512,-522 0,-364 249,-547 747,-547 211,0 410,33 597,99l0 365c-187,-78 -389,-116 -608,-116 -229,0 -344,61 -344,182 0,116 67,174 200,174l272 0c373,0 560,174 560,522 0,365 -238,547 -713,547 -234,0 -444,-33 -631,-100zm1560 -459c0,-346 243,-519 730,-519 114,0 228,11 342,33l0 -131c0,-156 -109,-234 -325,-234 -183,0 -387,28 -611,83l0 -348c224,-55 428,-83 611,-83 499,0 749,191 749,573l0 1168 -246 0 -151 -156c-146,104 -307,156 -483,156 -411,0 -616,-181 -616,-542zm1072 -187c-107,-22 -221,-33 -342,-33 -204,0 -306,72 -306,216 0,155 85,232 256,232 141,0 271,-45 392,-136l0 -278zm1899 -617c-69,-27 -168,-40 -296,-40 -293,0 -440,168 -440,502 0,324 127,486 380,486 121,0 240,-30 357,-89l0 -859zm424 1214c0,508 -295,762 -885,762 -207,0 -390,-28 -550,-83l0 -348c163,55 348,83 554,83 305,0 458,-132 458,-398 -126,55 -262,83 -406,83 -499,0 -749,-282 -749,-847 0,-573 291,-860 872,-860 196,0 431,24 707,71l0 1537zm321 -410c0,-346 243,-519 730,-519 114,0 228,11 342,33l0 -131c0,-156 -109,-234 -325,-234 -183,0 -387,28 -611,83l0 -348c224,-55 428,-83 611,-83 499,0 749,191 749,573l0 1168 -246 0 -151 -156c-146,104 -307,156 -483,156 -411,0 -616,-181 -616,-542zm1072 -187c-107,-22 -221,-33 -342,-33 -204,0 -306,72 -306,216 0,155 85,232 256,232 141,0 271,-45 392,-136l0 -278z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id0)",
    d: "M3915 380l0 0c131,0 237,107 237,237l0 1844c0,131 -107,237 -237,237l0 0c-131,0 -237,-107 -237,-237l0 -1844c0,-131 107,-237 237,-237zm3031 1306l0 -198c0,-131 -107,-237 -237,-237l0 0c-131,0 -237,107 -237,237l0 198c0,131 107,237 237,237l0 0c131,0 237,-107 237,-237zm-3736 -894l0 0c131,0 237,107 237,237l0 823c0,131 -107,237 -237,237l0 0c-131,0 -237,-107 -237,-237l0 -823c0,-131 107,-237 237,-237zm2834 0l0 0c131,0 237,107 237,237l0 823c0,131 -107,237 -237,237l0 0c-131,0 -237,-107 -237,-237l0 -823c0,-131 107,-237 237,-237zm-689 -594l0 0c131,0 237,107 237,237l0 1535c0,131 -107,237 -237,237l0 0c-131,0 -237,-107 -237,-237l0 -1535c0,-131 107,-237 237,-237zm-728 -198c131,0 237,107 237,237l0 1733c0,131 -107,237 -237,237l0 0c-131,0 -237,-107 -237,-237l0 -1733c0,-131 107,-237 237,-237z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9fe540dc3ce96a430cbf90daaa9eb83f.svg";
export { ForwardRef as ReactComponent };